import { memo } from 'react';

import { PageBreadcrumb } from '@/widgets/page-breadcrumb';

export const Header = memo(() => {
  return (
    <header className="shrink-0 pt-[1rem] pb-[1rem]">
      <div className="flex items-center justify-between max-w-[1000px] min-w-[1000px] mx-auto px-5 py-2 bg-muted/70 rounded-2xl">
        <div className="flex items-center flex-1 min-w-0">
          <PageBreadcrumb />
        </div>
      </div>
    </header>
  );
});
